/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type HighLevelTimeNumbers_project = {
    readonly id: string;
    readonly useBaseline: boolean | null;
    readonly billable: boolean | null;
    readonly financialNumbersToCurrentMonth: {
        readonly registeredMinutes: number | null;
        readonly billableActualMinutes: number | null;
        readonly nonBillableActualMinutes: number | null;
        readonly forecastMinutes: number | null;
        readonly baselineMinutes: number | null;
        readonly scopeApprovedMinutes: number | null;
        readonly projectedTotalMinutes: number | null;
        readonly projectedBillableMinutes: number | null;
        readonly projectedNonBillableMinutes: number | null;
    } | null;
    readonly " $refType": "HighLevelTimeNumbers_project";
};
export type HighLevelTimeNumbers_project$data = HighLevelTimeNumbers_project;
export type HighLevelTimeNumbers_project$key = {
    readonly " $data"?: HighLevelTimeNumbers_project$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"HighLevelTimeNumbers_project">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentYear",
      "type": "Int"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentMonth",
      "type": "Int"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentMonthLastDay",
      "type": "Int"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HighLevelTimeNumbers_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "useBaseline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billable",
      "storageKey": null
    },
    {
      "alias": "financialNumbersToCurrentMonth",
      "args": [
        {
          "kind": "Literal",
          "name": "convertToProjectCurrency",
          "value": true
        },
        {
          "kind": "Variable",
          "name": "endDay",
          "variableName": "currentMonthLastDay"
        },
        {
          "kind": "Variable",
          "name": "endMonth",
          "variableName": "currentMonth"
        },
        {
          "kind": "Variable",
          "name": "endYear",
          "variableName": "currentYear"
        }
      ],
      "concreteType": "FinancialNumbers",
      "kind": "LinkedField",
      "name": "financialNumbers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "registeredMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "billableActualMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nonBillableActualMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forecastMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "baselineMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "scopeApprovedMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectedTotalMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectedBillableMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectedNonBillableMinutes",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectType"
};
(node as any).hash = '434ce1b3fa31d9840a54d2269d223c95';
export default node;
